module.exports = __webpack_public_path__ + "static/personal-04e7754f4907d0ed0b5ef61e245932b4.svg";